<app-service-detail [location]="!context.service.isMyAccountPage ? 'nav.2_application_file' : null">

        <tutorial-layer *ngIf="context.service.tutorials && context.service.tutorials.serviceForms"
                class="inpage-tutorial {{ context.service.isMyAccountPage ? 'myaccount-tutorial' : ''}}"
                title="{{ 'nav.2_application_file' | translate }}" [isClosed]="true"
                [editorData]="context.service.tutorials.serviceForms" (saveTutorial)="saveTutorial($event)">
        </tutorial-layer>

        <app-apfiletabs *ngIf="!context.service.isMyAccountPage" [applicationFileData]="applicationFileData"
                [determinantMapById]="determinantMapById" [debugMode]="debugMode" [debugErrors]="debugErrors"
                (openFormBugsDrawer)="openFormBugsDrawerForForm($event.formId, $event.formName)"
                class="container-fluid px-md-5 mb-3"></app-apfiletabs>

        <guide-form *ngIf="applicationFileData[0].form && applicationFileData[0].isActive"
                [guideForm]="applicationFileData[0].form" [focusCompKey]="compKey"
                [determinantMapById]="determinantMapById" (formReverted)="onFormReverted($event, 0)"
                class="container-fluid px-md-5"></guide-form>

        <applicant-form *ngIf="applicationFileData[1].form && applicationFileData[1].isActive"
                [applicantForm]="applicationFileData[1].form" [focusCompKey]="compKey"
                [determinantMapById]="determinantMapById" (formReverted)="onFormReverted($event, 1)"
                class="container-fluid px-md-5 {{ context.service.isMyAccountPage ? 'mt-3' : ''}}"></applicant-form>

        <document-form *ngIf="applicationFileData[2].form && applicationFileData[2].isActive"
                [documentForm]="applicationFileData[2].form" [focusCompKey]="compKey"
                [determinantMapById]="determinantMapById" (formReverted)="onFormReverted($event, 2)"
                class="container-fluid px-md-5"></document-form>

        <payment-form *ngIf="applicationFileData[3].form && applicationFileData[3].isActive"
                [paymentForm]="applicationFileData[3].form" [focusCompKey]="compKey"
                [determinantMapById]="determinantMapById" (formReverted)="onFormReverted($event, 3)"
                class="container-fluid px-md-5"></payment-form>

        <sendfile-form *ngIf="applicationFileData[4].form && applicationFileData[4].isActive"
                [sendFileForm]="applicationFileData[4].form" [focusCompKey]="compKey"
                [determinantMapById]="determinantMapById" (formReverted)="onFormReverted($event, 4)"
                class="container-fluid px-md-5"></sendfile-form>

        <form-bugs-drawer
                [errors]="formBugsDrawerErrors"
                [isOpen]="formBugsDrawerOpen"
                [formName]="formBugsDrawerFormName"
                (closeEvent)="closeFormBugsDrawer()"
                (focusComponent)="onFocusComponent($event)">
        </form-bugs-drawer>
</app-service-detail>